import Overlay from 'overlay'
import $ from 'zepto'
import tapEvent from 'tapEvent'
let $body = $('body')

class Popbox {
  constructor() {
    this.elem = $(`<div class="popbox" style="user-select: all;">
      <div class="content">
        <div class="text"></div>
        <div class="btns"></div>
      </div>
    </div>`)
    this.overlay = new Overlay()

    this.overlay.on('tap', (e) => {
      this.hide()
    })
    this.elem.find('.close').on(tapEvent, () => {
      this.hide()
    })
    this.elem.css('zIndex', 130)
    this.elem.appendTo($body)
    this.hide()
  }
  _show(text, btns) {
    let $btnsContainer = this.elem.find('.btns')
    $btnsContainer.empty()
    btns.forEach((btn, i) => {
      const clickCb = (e) => {
        if (btn.fn) {
          btn.fn()
        } else {
          this.hide()
        }
      }
      let $btn = $(`<button>${btn.text}</button>`)
      $btn.addClass('btn-' + (i + 1))
      if (btn.active) {
        $btn.addClass('active')
      }
      $btn.css('width', (1 / btns.length) * 100 + '%')
      $btn.on('touchend', clickCb)
      $btn.on('click', clickCb)
      $btn.appendTo($btnsContainer)
    })
    this.elem.find('.text').html(text)
    this.overlay.show()
    this.elem.find('.close').show()
    this.elem.find('.btns button').removeClass('btn-blue')
    this.elem.show()
    this.elem.css('opacity', 1)
  }
  hide() {
    setTimeout(() => {
      this.cb && this.cb(-1)
      this.elem.css('opacity', 0)
      this.overlay.$el.css('opacity', 0)
      this.overlay.hide()
      this.elem.hide()
    }, 10)
  }
  show(text, btnTexts, cb) {
    this._show(
      text,
      btnTexts.map((text, i) => {
        return typeof text == 'string'
          ? {
            text: text,
            active: i == btnTexts.length - 1,
            fn: () => {
              this.hide()
              cb && cb(i)
            },
          }
          : text
      })
    )
  }
  confirmWithTitleAndMessage(title, message, btnTexts, cb) {
    this.cb = cb
    this._show(
      `
      <div class="title">${title}</div>
      <div class="desc">${message}</div>
    `,
      btnTexts.map(this._mapButtons(btnTexts, cb)),
      cb
    )
    this.elem.find('.btns button').addClass('btn-blue')
    this.elem.find('.close').hide()
  }
  _mapButtons(btnTexts, cb) {
    return (text, i) => {
      return typeof text == 'string'
        ? {
          text: text,
          active: i == btnTexts.length - 1,
          fn: () => {
            this.hide()
            cb && cb(i)
          },
        }
        : text
    }
  }
  confirm(text, btnTexts, cb) {
    this.cb = cb
    this._show(text, btnTexts.map(this._mapButtons(btnTexts, cb)))
  }
  alert(text, btnText) { }
}

export default new Popbox()



// WEBPACK FOOTER //
// ./src/mods/popbox.js